import React from "react";
import MountainPng from "../../assets/moon-surface-hd.png";

const Hero = () => {
  return (
    <div className="bg-black/20 h-full text-white relative z-50">
      <div className="h-full flex justify-center items-center p-4">
        <div className="container grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="space-y-4 lg:pr-36">
            <h1 data-aos="fade-up" className="text-4xl font-bold uppercase">
              Zemen Technology
            </h1>
            <p data-aos="fade-up" data-aos-delay="300">
              Zemen Tech is a professional software development company
              dedicated to shaping the future by streamlining operations for
              private institutions and modernizing information management. With
              a focus on solving operational and service-related challenges,
              Zemen enhances efficiency in both service and manufacturing
              sectors across Ethiopia.
            </p>
            <button
              data-aos="fade-up"
              data-aos-delay="500"
              className="primary-button"
            >
              Learn More
            </button>
          </div>
          <div></div>
        </div>
      </div>
      {/* surgace section */}
      <img
        src={MountainPng}
        alt=""
        className="absolute right-0 bottom-0 w-full brightness-50 z-10"
      />
      {/* bottom gradient section */}
      <div className="absolute bottom-0 w-full z-30 bg-gradient-to-b from-transparent from-10% to-black to-90% h-[20px] sm:h-[50px] md:[60px]"></div>
    </div>
  );
};

export default Hero;
